export default __webpack_public_path__ + "static/media/BBVA-logo.1c4137f1.png";